import { Icon } from '@apia/icons';
import { getLabel } from '@apia/util';
import { usePanelNetworkState } from '../../../actions';

export const NetworkState = ({ title }: { title: string }) => {
  const isConnected = usePanelNetworkState();
  return (
    <>
      {!isConnected && (
        <Icon
          tabIndex={0}
          title={
            getLabel('lblTestDBNoOk', {
              text: {
                TOK1: title,
              },
            }).text
          }
          aria-label={
            getLabel('lblTestDBNoOk', {
              text: {
                TOK1: title,
              },
            }).text
          }
          name="Alert"
        />
      )}
    </>
  );
};
